import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sidebar from "../features/sidebarSlice";
import theme from "../features/themeSlice";
import insCode from "../features/insCodeSlice";
import companies from "../features/companiesSlice";
import details from "../features/detailsSlice";
import sms from "../features/smsSlice";
import data from "../reducer";

const reducers = combineReducers({
  sidebar,
  theme,
  insCode,
  companies,
  details,
  sms,
  data,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
